import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleHalfStroke, faMoon, faSun } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import { themeContext } from "../providers/theme.provider"
import SegmentedPill from "../atoms/SegmentedPill"

const OPTIONS = [
	{ value: "auto", text: "Auto" },
	{ value: "light", text: "Chiaro" },
	{ value: "dark", text: "Scuro" },
]

// Sotto la riga c'è scritto cosa vuol dire quello che si è scelto, perché
// "auto" da solo non dice a cosa si adegua.
const DESCRIPTIONS = {
	auto: "Come le impostazioni del telefono",
	light: "Sempre chiaro",
	dark: "Sempre scuro",
}

const ICONS = { auto: faCircleHalfStroke, light: faSun, dark: faMoon }

function ThemeSelector() {
	const { mode, theme: currentTheme, setMode } = useContext(themeContext)

	return (
		<>
			<Div d="flex" align="center" style={{ gap: "0.75rem" }}>
				<Div
					w="40px"
					h="40px"
					rounded="circle"
					bg={currentTheme === "dark" ? theme.colors.gunmetal_fill : theme.colors.gray_light}
					d="flex"
					align="center"
					justify="center"
					transition
					style={{ flexShrink: 0 }}>
					<FontAwesomeIcon
						icon={ICONS[mode]}
						color={currentTheme === "dark" ? theme.colors.white : theme.colors.text_light}
					/>
				</Div>
				<Div>
					<Text textWeight="bold" textSize="subheader">
						Aspetto
					</Text>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						{DESCRIPTIONS[mode]}
					</Text>
				</Div>
			</Div>

			{/* La pastiglia sta sotto e non di fianco: tre scelte e un'etichetta
			    su uno schermo da telefono non ci stanno in riga. */}
			<Div m={{ t: "0.75rem" }}>
				<SegmentedPill options={OPTIONS} selected={mode} onChange={setMode} />
			</Div>
		</>
	)
}

export default ThemeSelector
